export class GeneralApiError extends Error {
  readonly type?: string;
  readonly responseStatus?: number;
  readonly responseBody?: unknown;
  constructor(responseStatus?: number, responseBody?: unknown) {
    super('An unexpected error occurred.');
    this.type = 'GeneralApiError';
    this.responseStatus = responseStatus;
    this.responseBody = responseBody;
  }
}
